import {BaseWrapper} from '../../../allkey/framework/parameters/BaseWrapper';
import {BasicScenario} from '../../../allkey/framework/parameters/BasicScenario';
import {ConnectionCriteria} from './ConnectionCriteria';
import {MailConnection} from '../message/MailConnection';

export class MailConnectionWrapper extends BaseWrapper<MailConnection, ConnectionCriteria, BasicScenario>  {}

